export enum CardProcessorsEnum {
  AMERICAN_EXPRESS = 'american express',
  AMEX = 'amex',
  MASTER_CARD = 'mastercard',
  VISA = 'visa',
}
